<template>
	<v-container class="login-container">
		<v-layout class="login_background" flex-wrap justify-center>
			<v-flex xs12>
				<div :style="`background-color: ${$store.state.PointColor1};`" style="max-width:600px; margin:0 auto; height: 100vh;" class="pt-6">
					<v-card class="waitingCheck pa-4 mb-0" elevation="0">
						<v-img style="margin: 0 auto;" src="/image/waitingCheck.png" width="92" contain></v-img>
						<div class="reserveCheck-header-text my-2">
							상담 대기 팀을 확인하세요
						</div>
					</v-card>
					<div class="waitingCheck-dash" :style="$vuetify.breakpoint.xs ? 'max-width:85%;' : ''"></div>
					<v-card class="waitingCheck mt-0 px-4 pt-8 pb-6" elevation="5" v-if="realWait">
						<v-layout justify-center class="mx-4">
							<v-flex xs12>
								<v-layout align-center justify-center>
									<div class="reserveCheck-text-1 pt-1" style="font-size: 21px;">
										내 앞 상담 대기 팀
									</div>
									<div class="reserveCheck-text-2 ml-4">
										<span class="impact mr-1">{{ frontnum }}</span
										>명
									</div>
								</v-layout>
							</v-flex>
						</v-layout>
						<v-layout class="mt-7 px-2">
							<span class="mr-1" style="font-size: 13px;">※</span>
							<div class="reserveCheck-text-3 text-left">
								고객님의 상담 순서가 되면 상담석 안내 알림톡이 발송됩니다. 내방 고객의 빠르고 원활한 상담 진행을 위하여 상담석 안내 후
								일정시간이 경과하면 사전고지 없이 상담 예약이 취소될 수 있습니다.
							</div>
						</v-layout>
						<div class="pt-8">
							<btn :btn="closeBtn" btn_txt="새로고침" @click="refresh()"></btn>
						</div>
					</v-card>
					<v-card class="waitingCheck mt-0 px-4 pt-8 pb-6" elevation="5" v-else>
						<v-layout class="px-2">
							<div class="reserveCheck-text-1 pt-1" v-if="noData">
								상담신청을 하지않은 고객입니다. <br />
								방문등록 부터 진행 후 알림톡을 통하여 상담신청을 해주세요.
							</div>
							<div class="reserveCheck-text-1 pt-1" v-else>
								{{ statText }} <br />
								알림톡을 확인해 주세요. <br />
							</div>
						</v-layout>
					</v-card>
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { btn } from '@/components/index.js'
export default {
	components: {
		btn,
	},
	metaInfo() {
		return {
			title: '상담신청 실시간 체크',
			socket: null,
		}
	},
	mounted() {},
	data() {
		return {
			statText: '',
			noData: false,
			countDown: 0,
			userInfo: { name: '', cdate: '', waitingnum: '' }, // 고객 waiting 정보
			frontnum: 0, //현재 대기자 수
			closeBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn',
				color: this.$store.state.PointColor1,
			},
			nextBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn',
				color: this.$store.state.PointColor1,
			},
			realWait: '', // 신청 유무
			nowaitUser: { show: false }, // 예약 없을 시 고객 데이터
			alertModal: {
				dialog: false,
				text: '',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			screenWidth: window.innerWidth,
			reservedaysData: {},
			socket: '',
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	async created() {
		if (this.$route.params.code === '09buhz2luv1') {
			this.$router.push({ name: 'waitingCheck', params: { code: '09buhz2luv', groupcode: '09buhz2luv' } })
		}
		await this.realTimeWait()
		// await this.reservedays()
	},
	methods: {
		async reservedays() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
			}
			await this.$store.dispatch('reservedays', data).then(res => {
				this.reservedaysData = res.data.reservedays[0]
			})
		},

		async realTimeWait() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				phone: this.$route.params.phone,
				date: this.$moment().format('YYYY-MM-DD'),
			}
			await this.$store
				.dispatch('realTimeWait', data)
				.then(res => {
					let waitInfo = res.data.realTimeWait.count
					this.userInfo.name = waitInfo.name
					this.userInfo.cdate = this.$moment(waitInfo.cdate)
						.subtract(9, 'hours')
						.format('YYYY년 MM월 DD일 HH:mm')
					this.userInfo.waitingnum = waitInfo.waitingnum
					this.frontnum = waitInfo.frontnum
					this.$store.state.loading = false
					this.realWait = true
				})
				.catch(() => {
					this.nowaitings()
					this.$store.state.loading = false
					this.realWait = false
					// this.alertModal2.dialog = true
					// this.alertModal2.text = '상담 신청 내역이 없습니다'
					// this.$store.state.loading = false
				})
		},
		waitings() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				phone: this.$route.params.phone,
				csdate: this.$moment().format('YYYY-MM-DD'),
				stat: 0,
			}
			this.$store
				.dispatch('waitings', data)
				.then(res => {
					this.deletewaiting(res.data.waitings[0].id)
				})
				.catch(() => {
					this.alertModal2.dialog = true
					this.alertModal2.text = '상담 신청 내역이 없습니다'
					this.$store.state.loading = false
				})
		},
		nowaitings() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				phone: this.$route.params.phone,
				csdate: this.$moment().format('YYYY-MM-DD'),
			}
			this.$store
				.dispatch('simpleWaitings', data)
				.then(res => {
					if (res.data.waitings.length === 0) {
						this.noData = true
					} else {
						res.data.waitings.sort((a, b) => {
							return b.id - a.id
						})
						if (res.data.waitings[0].stat === 1) return (this.statText = '상담호출된 고객입니다.')
						if (res.data.waitings[0].stat === 2) return (this.statText = '상담취소된 고객입니다.')
						if (res.data.waitings[0].stat === 9) return (this.statText = '상담완료된 고객입니다.')
					}
				})
				.catch(() => {})
		},
		refresh() {
			this.$store.state.loading = true
			this.countDown = 5
			const countDown = setInterval(() => {
				this.countDown -= 1
				if (this.countDown === 0) {
					clearInterval(countDown)
				}
			}, 1000)
			this.realTimeWait()
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		close() {
			//창닫기
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
			document.getElementById('closeWaiting').click()
		},
		cancel() {
			//상담 취소 클릭
			this.alertModal.dialog = true
			this.alertModal.text = '상담 신청을 취소하시겠습니까?'
		},
		deletewaiting(id) {
			//상담 취소
			const data = {
				id: id,

				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				custlike: '미처리',
				stat: 2,
			}
			this.$store
				.dispatch('updateWaiting', data)
				.then(res => {
					this.alertModal2.dialog = true
					this.alertModal2.text = '상담 신청이 취소되었습니다'
					this.unattendedMessage(res.data.updateWaiting.waiting)
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		unattendedMessage(reserveuser) {
			const data = {
				tplCode: this.reservedaysData.tplCode[7],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let reserveDayurl = `${location.protocol}//${location.hostname}/reserve_day/${
						this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code
					}`
					const bookday = this.$moment(reserveuser.created_at).format('YYYY년MM월DD일 HH:mm')
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, reserveuser.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담신청일시}/g, bookday)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{예약URL}/g, reserveDayurl)
					}
					let buttonData = res.data.messages[0].button
					const buttonsData = JSON.parse(res.data.messages[0].button).button
					buttonsData.forEach(element => {
						element.linkMo = element.linkMo.replace(
							/#{그룹}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkPc = element.linkPc.replace(
							/#{그룹}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkMo = element.linkMo.replace(
							/#{코드}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkPc = element.linkPc.replace(
							/#{코드}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.$route.params.phone)
						element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.$route.params.phone)
						element.linkMo = element.linkMo.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
							element.linkMo = element.linkMo.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
						}
						element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					})
					buttonData = JSON.stringify(buttonsData)
					const sendData = {
						// 필수값

						code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						tpl_code: res.data.messages[0].tplCode,
						receiver_1: reserveuser.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: reserveuser.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: buttonData ? buttonData : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		toDirect() {
			this.$router
				.push({
					name: 'reservedirect',
					params: { code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code },
				})
				.catch(() => {})
		},
	},
}
</script>

<style lang="scss" scoped>
html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
li,
dl,
dt,
dd,
table,
th,
td,
form,
fieldset,
legend,
input,
textarea,
button {
	font-family: 'Noto Sans KR', 'Apple SD Gothic Neo';
	margin: 0;
	padding: 0;
	letter-spacing: -1px;
}
li {
	list-style: none;
}
img,
fieldset {
	border: none;
	margin: 0;
	padding: 0;
}
</style>
